import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Page } from "~/components/Page";
import { FETCH_NEW_FEATURES_SUCCESS } from "~/store/action_types";
import { fetchNewFeatures } from "~/store/actions/actions.newFeatures";
import Angie from "~/utils/angie";
import NewFeaturesList from "./NewFeaturesList";

const NewFeaturesPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const title = t("New Features");
  const [newFeatures, setNewFeatures] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    dispatch(fetchNewFeatures()).then((result) => {
      if (result.type === FETCH_NEW_FEATURES_SUCCESS) {
        setNewFeatures(result.response);
        setIsLoading(false);
        Angie.functions.removeUnreadIndicator();
      }
    });
  }, [dispatch]);

  return (
    <Page title={title}>
      <Page.Header title={title} />
      <Page.Body className="tw-flex tw-h-full tw-flex-col">
        <NewFeaturesList
          newFeatures={newFeatures}
          loading={isLoading}
        />
      </Page.Body>
    </Page>
  );
};

export default NewFeaturesPage;
